var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.image)?_c('VcImage',{staticClass:"image",attrs:{"image":_vm.image}}):_c('VcIcon',{staticClass:"icon-wrapper",attrs:{"size":20,"color":"white"}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }